import React from "react";
const Idea = (props) => {
  return (
    <svg
    fill="#000"
    height="200px"
    width="200px"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    {...props}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <g>
        <g>
          <path d="M256.048,9.633c-50.246,0-91.123,40.878-91.123,91.123c0,29.086,14.044,56.413,37.213,73.464v53.057 c0,9.222,7.477,16.699,16.699,16.699h20.513v8.61c0,9.222,7.477,16.699,16.699,16.699c9.222,0,16.699-7.477,16.699-16.699v-8.61 h20.514c9.222,0,16.699-7.477,16.699-16.699V174.22c23.169-17.052,37.212-44.379,37.212-73.464 C347.172,50.511,306.294,9.633,256.048,9.633z M276.562,210.579h-41.027v-7.762h41.027V210.579z M284.9,150.768 c-9.198,5.32-8.337,14.563-8.337,18.651h-41.027c0-3.798,1.007-13.247-8.337-18.651c-17.811-10.303-28.876-29.466-28.876-50.011 c0-31.831,25.895-57.726,57.726-57.726c31.83,0,57.726,25.895,57.726,57.726C313.774,121.303,302.711,140.465,284.9,150.768z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M501.108,327.805c-18.077-22.784-51.249-26.096-73.456-7.46l-79.113,66.383h-37.11 c18.518-7.578,31.898-25.423,32.467-46.178c0.797-29.076-22.488-52.931-51.476-52.931H137.134v-15.706 c0-9.222-7.477-16.699-16.699-16.699H16.699C7.477,255.215,0,262.692,0,271.914v213.754c0,9.222,7.477,16.699,16.699,16.699 h103.736c9.222,0,16.699-7.477,16.699-16.699v-27.328l32.694,27.431c9.007,7.557,20.442,11.718,32.199,11.718h156.499 c11.757,0,23.192-4.161,32.201-11.719l102.571-86.061C514.766,381.693,518.272,349.438,501.108,327.805z M103.736,468.969H33.398 V288.613h70.339C103.736,295.615,103.736,460.353,103.736,468.969z M471.829,374.122l-102.57,86.061 c-3.004,2.519-6.815,3.908-10.735,3.908H202.027c-3.92,0-7.729-1.387-10.733-3.905l-54.16-45.44v-93.728h155.284 c10.112,0,18.373,8.304,18.091,18.618c-0.266,9.693-8.706,17.578-18.815,17.578c-7.262,0-59.114,0-65.688,0 c-9.222,0-16.699,7.477-16.699,16.699c0,9.222,7.477,16.699,16.699,16.699h29.59l25.868,21.703 c6.005,5.037,13.627,7.813,21.466,7.813h45.608c7.841,0,15.465-2.775,21.467-7.814l79.113-66.383 c7.762-6.513,19.426-5.434,25.825,2.634C480.971,356.159,479.574,367.625,471.829,374.122z" />
        </g>
      </g>
    </g>
  </svg>
  );
};

export default Idea;
